const TEXT_FONT = 'MuseoSansRounded';
const DISPLAY_FONT = 'MuseoSansRounded';

module.exports.default = {
  '--aero': '#dff6f1',
  '--aquamarine': '#55c7ff',
  '--buttercup': '#f3b10d',
  '--carissma': '#e88fa4',
  '--cerulean': '#157bc1',
  '--chama-blue': '#4786ff',
  '--chama-malibu': '#079de7',
  '--comet': '#4c5167',
  '--coral': '#f46467',
  '--cornflower': '#8488f1',
  '--crail': '#BA4043',
  '--dodger': '#3a6fcf',
  '--fair': '#ffecec',
  '--flamingo': '#f75f28',
  '--ivory': '#fdf1ea',
  '--jungle': '#2a8471',
  '--lavender': '#7563e0',
  '--mystic': '#e5e8f1',
  '--nepal': '#99a3c8',
  '--nobel': '#c5cbe1',
  '--pomegranate': '#ef4b10',
  '--sail': '#50afff',
  '--scorpion': '#5e647f',
  '--selago': '#e4e4fe',
  '--shamrock': '#50e3c2',
  '--squeeze': '#f6f7fc',
  '--sunglow': '#ffd42d',
  '--turquoise': '#219E83',
  '--valencia': '#cf474a',
  '--zircon': '#EEF4FF',
  '--white': '#ffffff',

  /* Z-INDEX */
  '--Zindex-level-1': 100,
  '--Zindex-level-2': 200,
  '--Zindex-level-3': 300,
  '--Zindex-level-4': 400,
  '--Zindex-level-5': 500,
  '--Zindex-level-6': 600,
  '--Zindex-level-7': 700,
  '--Zindex-level-8': 800,
  '--Zindex-level-9': 800,
  '--Zindex-level-above-modal': 1200,
  '--Zindex-level-above-overlay': 1100,
  '--Zindex-level-lowest': 1,
  '--Zindex-level-max': 1000,

  /* FONTS */
  '--Global-display-font': DISPLAY_FONT,
  '--Global-text-font': TEXT_FONT,

  /* FONT-WEIGHT */
  '--Font-weight-regular': 500,
  '--Font-weight-semibold': 700,
  '--Font-weight-bold': 900,

  /* SIZES */
  '--Global-container-width': '1280px',
  '--Global-page-side-padding': '24px',
  '--Global-row-side-padding': '16px',
};



// WEBPACK FOOTER //
// ../statics/stylesheets/variables.js